// Integration Task panding
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MedicineModel } from '../../models'


export interface MedicineState {
    Medicine: MedicineModel
    MedicineList: MedicineModel[]
}

const initialState: MedicineState = {
    Medicine: {
        MedicineID: 0,
        MedicineName: "",
        OtherName: "",
        CompanyName: "",
        Type: "",
        IsComposed: true,
        TakeWith: "",
        WhenToTake: "",
        IsActive: true, 
    },
    MedicineList: [],
}

export const MedicineSlice = createSlice({
    name: 'medicine',
    initialState,
    reducers: {
        setMedicine: (state, action: PayloadAction<MedicineModel[]>) => {
            state.MedicineList = action.payload
        },
        saveMedicine: (state, action: PayloadAction<MedicineModel>) => {
            let model = action.payload
            if (model.MedicineID > 0) {
                let defaultModel: MedicineModel = {
                    MedicineID: model.MedicineID,
                    MedicineName: model.MedicineName,
                    OtherName: model.OtherName,
                    CompanyName: model.CompanyName,
                    Type: model.Type,
                    IsComposed: model.IsComposed,
                    TakeWith: model.TakeWith,
                    WhenToTake: model.WhenToTake,
                    IsActive: model.IsActive,
                }
                let currentModel = state.MedicineList.find((c) => c.MedicineID === model.MedicineID) || defaultModel
                currentModel.MedicineName = model.MedicineName,
                currentModel.OtherName = model.OtherName,
                currentModel.CompanyName = model.CompanyName,
                currentModel.Type = model.Type,
                currentModel.IsComposed = model.IsComposed,
                currentModel.TakeWith = model.TakeWith,
                currentModel.WhenToTake = model.WhenToTake,
                currentModel.IsActive = model.IsActive
            } else {
                model.MedicineID = (Math.max(...state.MedicineList.map((c) => c.MedicineID)) || 0) + 1
                state.MedicineList.push(model)
            }
        },
        getMedicine: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let model: MedicineModel = initialState.Medicine
            if (id > 0) {
                let currentList: MedicineModel[] = state.MedicineList
                model = currentList.find((c) => c.MedicineID === id) || initialState.Medicine
            }
            state.Medicine = model
        },
        deleteMedicine: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentList: MedicineModel[] = state.MedicineList
                state.MedicineList = currentList.filter((c) => !ids.includes(c.MedicineID))
            }
        },
    },
})

export const { setMedicine, saveMedicine, getMedicine, deleteMedicine } =
    MedicineSlice.actions

export default MedicineSlice.reducer
